import { Injectable } from '@angular/core';
import { UserClient } from '@clearing-hub/common';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  constructor(private readonly httpClient: HttpClient) {}

  getUserPoolInfo() {
    return this.httpClient.get('/adm/api/authentication/user-pool');
  }

  static isLogined(): boolean {
    return localStorage.getItem('currentAdmin') != null;
  }

  static getUser(): UserClient {
    try {
      return JSON.parse(localStorage.getItem('currentAdmin'));
    } catch (e) {
      return null;
    }
  }

  getUserPermissions() {
    const user = AuthenticationService.getUser();
    return user ? user.permissions : [];
  }
}
